import { Stack, Typography } from '@mui/material'
import { C1Card } from 'components/core/card/C1Card'
import React, { FC } from 'react'

export type C1SelectCardProps = {
    title: string
    description?: string
    icon?: React.ReactNode
    isSelected: boolean
    onClick: () => void
    disabled?: boolean
    ariaLabel?: string
}

export const C1SelectCard: FC<C1SelectCardProps> = ({
    title,
    description,
    icon,
    isSelected,
    onClick,
    disabled,
    ariaLabel,
}) => (
    <C1Card
        isSelected={isSelected}
        onClick={disabled ? undefined : onClick}
        ariaLabel={ariaLabel ?? title}
        sx={{
            flex: 1,
            p: 2,
            mb: 0,
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.5 : 1,
        }}
    >
        <Stack direction="row" spacing={2} alignItems="flex-start">
            {icon && <Stack justifyContent="center" sx={{ minHeight: '24px' }}>{icon}</Stack>}
            <Stack spacing={1}>
                <Typography>{title}</Typography>
                {description && (
                    <Typography variant="caption" color="text.secondary">
                        {description}
                    </Typography>
                )}
            </Stack>
        </Stack>
    </C1Card>
)
